import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviInterventionState } from './state';

export const getters: GetterTree<SuiviInterventionState, RootState> = {
    getSuiviInterventionsItems(state) {
        return state.interventions;
    },
    getSuiviInterventionFilterSite(state): Array<number> {
        return state.filterSite;
    },
    getSuiviInterventionFilterStatus(state): Array<string> {
        return state.filterStatus;
    },
    getSuiviInterventionFilterInterventionId(state): string {
        return state.filterInterventionId;
    },
    getSuiviInterventionFilterPredictedDateFrom(state): string {
        return state.filterPredictedDateFrom;
    },
    getSuiviInterventionFilterPredictedDateTo(state): string {
        return state.filterPredictedDateTo;
    },
    getSuiviInterventionsIsLoading(state) {
        return state.isLoading;
    },
    getSuiviInterventionsPage(state) {
        return state.page;
    },
    getSuiviInterventionsNbOfPages(state) {
        return state.nbOfPages;
    },
    getSuiviInterventionsScroll(state) {
        return state.scroll;
    },
    getSuiviInterventionsSort(state) {
        return state.sort;
    },
    getSuiviInterventionsCount(state) {
        return state.count;
    },
    getSuiviInterventionsTableHeader(state) {
        return state.tableHeader;
    },
    getSuiviInterventionsExportXlsIsLoading(state) {
        return state.isExportXlsLoading;
    },
};
